export const STATUS_LABEL = {
  searching: 'Searching',
  driver_assigned: 'Assigned',
  arrived: 'Arrived',
  started: 'On trip',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const STATUS_CLASS = {
  searching: 'orange',
  driver_assigned: 'blue',
  arrived: 'blue',
  started: 'green',
  completed: 'gray',
  cancelled: 'red',
};

export const ACTIVE_STATUSES = ['searching', 'driver_assigned', 'arrived', 'started'];

export const toJsDate = (v) => {
  if (!v) return null;
  if (typeof v.toDate === 'function') return v.toDate();
  if (typeof v.toMillis === 'function') return new Date(v.toMillis());
  if (typeof v.seconds === 'number') return new Date(v.seconds * 1000);
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  if (typeof v === 'number') return isNaN(v) ? null : new Date(v);
  if (typeof v === 'string') {
    const parsed = new Date(v);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};

export const isSameDay = (date, ref = new Date()) => {
  const d = toJsDate(date);
  const r = toJsDate(ref) || new Date();
  if (!d) return false;
  return (
    d.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
      === r.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' })
  );
};

export const istDayKey = (value) => {
  const d = toJsDate(value);
  return d ? d.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' }) : null;
};

const DAY_MS = 24 * 60 * 60 * 1000;

export const RANGE_OPTIONS = [
  ['all', 'All time'],
  ['today', 'Today'],
  ['yesterday', 'Yesterday'],
  ['7d', 'Last 7 days'],
  ['30d', 'Last 30 days'],
  ['custom', 'Custom dates'],
];

// Returns inclusive [fromKey, toKey] IST day strings, or null for "all time".
export const rangeBounds = (range, customFrom, customTo) => {
  const now = Date.now();
  const today = istDayKey(now);
  switch (range) {
    case 'today': return [today, today];
    case 'yesterday': { const y = istDayKey(now - DAY_MS); return [y, y]; }
    case '7d': return [istDayKey(now - 6 * DAY_MS), today];
    case '30d': return [istDayKey(now - 29 * DAY_MS), today];
    case 'custom': {
      if (!customFrom && !customTo) return null;
      const from = customFrom || customTo;
      const to = customTo || customFrom;
      return from <= to ? [from, to] : [to, from];
    }
    default: return null;
  }
};

export const inBounds = (value, bounds) => {
  if (!bounds) return true;
  const k = istDayKey(value);
  return !!k && k >= bounds[0] && k <= bounds[1];
};

export const minutesAgo = (date) => {
  const d = toJsDate(date);
  if (!d) return null;
  return Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
};

/** Searching >5m, or assigned/arrived with no update >10m. */
export const getStuckRides = (rides, {
  searchingMins = 5,
  assignedMins = 10,
} = {}) => {
  const list = [];
  for (const r of rides || []) {
    if (r.status === 'searching') {
      // Age from when the search (re)started, the same clock the server's
      // auto-expiry uses. An Anna cancel or an admin rebroadcast restarts it, so
      // a rebroadcast ride leaves this list instead of looking untouched at "5m".
      const mins = minutesAgo(r.searchStartedAt || r.createdAt);
      if (mins != null && mins >= searchingMins) {
        list.push({ ...r, stuckReason: 'searching', stuckMins: mins });
      }
      continue;
    }
    if (r.status === 'driver_assigned' || r.status === 'arrived') {
      const mins = minutesAgo(r.updatedAt || r.createdAt);
      if (mins != null && mins >= assignedMins) {
        list.push({
          ...r,
          stuckReason: r.status === 'arrived' ? 'arrived_stale' : 'assigned_stale',
          stuckMins: mins,
        });
      }
    }
  }
  return list.sort((a, b) => (b.stuckMins || 0) - (a.stuckMins || 0));
};

export const dayKey = (date) => {
  if (!date) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
